import React from 'react';
import { Box } from '@mui/material';
import { useAppSelector } from '../../../../../app/store';
import { useGetFeeSchedulesByContractIdQuery } from '../../../../../services/ContractService';
import FeeScheduleGrid from '../../grids/contractGrids/FeeScheduleGrid';
import { AddEditFeeScheduleDialog } from '../../dialogs/contractDialogs';

const CptTab: React.FC = () => {
  const contract = useAppSelector((state) => state.contract.currentContract);
  
  // Query to get all fee schedules for this contract
  const { data: allFeeSchedules, isLoading, error } = useGetFeeSchedulesByContractIdQuery(
    { contractId: contract?.id || '' },
    { skip: !contract?.id }
  );

  // Filter for CPT fee schedules only
  const cptFeeSchedules = allFeeSchedules?.filter(fs => fs.feeType === 'CPT') || [];

  return (
    <Box>
      <FeeScheduleGrid
        title="CPT Fee Schedules"
        feeSchedules={cptFeeSchedules}
        isLoading={isLoading}
        error={error}
        contractId={contract?.id}
        company={contract?.company}
        actions={<AddEditFeeScheduleDialog feeType="CPT" />}
      />
    </Box>
  );
};

export default CptTab;
